export function formatDownloadState(state) {
    return String(state || 'unavailable')
        .split('_')
        .join(' ')
        .replace(/\b\w/g, letter => letter.toUpperCase());
}

export function isDownloadDisabled(download) {
    return download.state === 'unavailable' || download.state === 'preparing';
}

export function getDownloadActionText(download) {
    if (download.state === 'failed') return 'Retry';
    if (download.processRequest || download.state === 'available') {
        return 'Prepare';
    }
    return 'Download';
}
